import { Component, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";

import { BfxDialogCommand } from "./models/bfx-dialog-command.enum";
import { BfxDialogData } from "./models/bfx-dialog-data.model";

import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";

import { OrdersTableDefinitionFactory, TableDefinition } from "shared/cubiq-services";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

const DEFAULT_CONFIRMATION_MESSAGE_I18N_KEY = "order_entry.dialog.close.subMessage";

@Component({
  selector: `bfx-dialog-confirm`,
  templateUrl: `./html/bfx-dialog-confirm.html`,
  standalone: false,
})
export class BfxDialogConfirmComponent extends BfxDialogBaseComponent {
  public title: string = "";
  public messages: Array<string> = [];
  public tableDefinition: TableDefinition = null;
  public subMessage: string = null;
  public showConfirmationMessage: boolean = true;
  public confirmationMessage: string = "";
  public confirmed: boolean = false;
  public showLogoutMessage: boolean = false;

  public data: any = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      count: 0,
      class_name: "bfx-dialog-normal",
    },
  };

  constructor(
    protected layoutService: GoldenLayoutService,
    protected translationService: TranslateService,
    ordersTableDefinitionFactory: OrdersTableDefinitionFactory,
    private _element: ElementRef,
  ) {
    super();
    this.tableDefinition = ordersTableDefinitionFactory.createDef();
  }

  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;

      if (_dialogData.payload != null) {
        this.messages = _dialogData.payload.messages;
        this.title = _dialogData.payload.title;
        this.subMessage = _dialogData.payload.subMessage;
        if (_dialogData.payload.showConfirmationMessage != null) {
          let i18nKey =
            typeof _dialogData.payload.confirmationMessage === "string"
              ? _dialogData.payload.confirmationMessage
              : DEFAULT_CONFIRMATION_MESSAGE_I18N_KEY;
          this.confirmationMessage = this.translationService.instant(i18nKey);
          this.showConfirmationMessage = _dialogData.payload.showConfirmationMessage;
        }

        if (_dialogData.payload.showLogoutMessage)
          this.showLogoutMessage = _dialogData.payload.showLogoutMessage;

        if (_dialogData.command != BfxDialogCommand.DIALOG_GENERIC_CONFIRM_OPEN)
          this.data.dialogData.class_name = "bfx-dialog-warning";
      }

      if (this.messages.length > 0 || _dialogData.payload.showLogoutMessage) {
        this.title = _dialogData.payload.showLogoutMessage
          ? this.translationService.instant("logout.warning.title")
          : this.translationService.instant(this.title);
        NativeDesktopSupport.prepareEmbeddedDialog(_dialogData.body, this._dialog, this._element);
        this.data.dialogData.show = true;
      }
    } catch (ex) {
      logger.out.error("ERROR: BfxDialogConfirmComponent.openDialog(): Dialog exception! msg:", ex);
    }

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    if (this.data.payload.callbackNegative && !this.confirmed) {
      this.data.payload.callbackNegative(this.data.actionEvent);
    }

    super.closeDialog();

    this.data.dialogData.title_text = null;
    this.data.dialogData.message_text = null;
    this.data.dialogData.message_text_ids = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;

    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  public actionConfirmed(): void {
    this.confirmed = true;
    this.data.payload.callback(this.data.actionEvent);
    this.closeDialog();
  }
}
